import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

export default function HeaderImage(props) {
  const theme = useMantineTheme();
  const space = useSelector((state) => state.space);
  const space2 = useSelector((state) => state.space2);
  const hiddenCover = useSelector((state) => state.hiddenCover);
  const hiddenSidebar = useSelector((state) => state.hiddenSidebar);

  const [image, setImage] = useState({ url: null });

  useEffect(() => {
    if (getSpace() && getSpace().header) {
      setImage(getSpace().header);
    }
  }, [space, space2]);

  const getSpace = () => {
    if (props.useSpace2) {
      return space2;
    } else {
      return space;
    }
  };

  if (hiddenCover.hidden) {
    return null;
  }

  const wideWidth = getSpace().space_width == "wide" ? 960 - 35 : 801 - 35;
  const isFullWidth = (typeof getSpace().is_cover_full_width === "boolean" ? getSpace().is_cover_full_width : true) || props.useSpace2;
  const largeScreen = useMediaQuery(hiddenSidebar?.hidden
    ? `(max-width: ${wideWidth}px)`
    : `(max-width: ${wideWidth + Number(theme.other.sideFrameWidth)}px)`
  );

  const borderRadius = (radius) => {
    if (isFullWidth || largeScreen) {
      return "0px";
    } else {
      return `${props.radius || radius}px`;
    }
  };

  return (
    <>
      {typeof image.url === "string" && (
        <div
          className={`header-image`}
          style={{
            backgroundImage: `url(${image.url})`,
            borderRadius: borderRadius(0),
            maxWidth: isFullWidth ? "100%" : `${wideWidth}px`,
            margin: isFullWidth ? "0" : "0 auto",
            borderBottomLeftRadius: borderRadius(10),
            borderBottomRightRadius: borderRadius(10)
          }}
        />
      )}
    </>
  );
}
